/**
 * Air vent icon component
 */
export function AirVentIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="112" height="112" viewBox="0 0 112 112" fill="none">
      <g clip-path="url(#clip0_4875_4567)">
        <path
          d="M42 60.6665C42 64.3795 43.475 67.9405 46.1005 70.566C48.726 73.1915 52.287 74.6665 56 74.6665C59.713 74.6665 63.274 73.1915 65.8995 70.566C68.525 67.9405 70 64.3795 70 60.6665C70 56.9535 68.525 53.3925 65.8995 50.767C63.274 48.1415 59.713 46.6665 56 46.6665C52.287 46.6665 48.726 48.1415 46.1005 50.767C43.475 53.3925 42 56.9535 42 60.6665Z"
          stroke="#A1BDEC"
          stroke-width="8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M66.1126 49C69.4819 41.8227 71.5073 34.7993 72.1933 27.9347C73.2199 20.328 68.6373 14 55.9999 14C43.3626 14 38.7799 20.3327 39.8066 27.9347C40.4926 34.7993 42.5179 41.8227 45.8873 49"
          stroke="#A1BDEC"
          stroke-width="8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M61.4556 78.1714C65.9822 84.6814 71.0549 89.9454 76.6549 93.9728C82.7216 98.6394 90.5009 97.8601 96.8196 86.9168C103.138 75.9734 99.9462 68.8381 92.8529 65.9261C86.5622 63.0888 79.4689 61.3294 71.5636 60.6621"
          stroke="#A1BDEC"
          stroke-width="8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M40.4322 60.6665C32.5316 61.3338 25.4382 63.0932 19.1522 65.9305C12.0496 68.8378 8.85757 75.9778 15.1762 86.9212C21.4949 97.8645 29.2696 98.6672 35.3409 93.9772C40.9409 89.9498 46.0136 84.6858 50.5449 78.1758"
          stroke="#A1BDEC"
          stroke-width="8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4875_4567">
          <rect width="112" height="112" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
